import React, { FC } from 'react'
import { CustomerCard } from 'components/Card'

type Props = {
  userId: string
}

const StoreCustomerModal: FC<Props> = (props) => {
  const { userId } = props
  return <CustomerCard userId={userId} isShownByModal={true} />
}

export default StoreCustomerModal
